// reducer.js
import {
  SET_VALUE_ModeleInvestissement,
  SET_TYPE_ModeleInvestissement,
  SET_CURRENT_PAGE_ModeleInvestissement,
  SET_ORDER_ModeleInvestissement,
  SET_SORT_FIELD_ModeleInvestissement,
  SET_ACTIF_ModeleInvestissement,
  SET_CATEGORIE_ModeleInvestissement,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleInvestissement:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleInvestissement:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleInvestissement:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleInvestissement:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleInvestissement:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleInvestissement:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleInvestissement:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
